// Environment placeholder template for token substitution
// Tokens will be replaced during Azure DevOps pipeline build
// Token format: #{VariableName}#

export const environment = {
  production: true,
  name: 'DEV',
  apiBaseUrl: 'https://propertymdm-api-dev.cushwake.com',
  redirectUri: 'https://propertymdm-dev.cushwake.com',
  msalTenantId: '46c5178e-a0f4-4f4d-8c40-9598e3d11860',
  msalClientId: '343ec389-81d0-44af-a298-3320592e88be',
  msalRequestScopes: ['api://e3dda00b-86cf-42b3-ab9a-0191a38494c5/MdmClient.Access'],
  appInsightsInstrumentationKey: '2c379012-21b5-44b4-9e98-a7a424ac725c',
  appInsightsEnableTrackEvents: ('true' as string) === 'true',

  // Feature switches for actions that create or bulk-load data. An unset pipeline variable
  // leaves the token unreplaced, which is not 'true', so the feature stays hidden -- the safe
  // direction for write operations.
  features: {
    addProperty: ('$(FrontEnd-FeatureAddProperty)' as string) === 'true',
    createPortfolio: ('$(FrontEnd-FeatureCreatePortfolio)' as string) === 'true',
    bulkUpload: ('$(FrontEnd-FeatureBulkUpload)' as string) === 'true',
  },
};
